<div class="fb-vd-profile py-4 px-6 flex flex-col justify-center items-center relative">
	<div mat-dialog-close
		 class="absolute top-0 left-0 px-2 pt-2 bg-[#D4A373] rounded">
			<span class="material-symbols-outlined cursor-pointer text-white">
				close
			</span>
	</div>
	<h2 class="font-bold text-[#3c3c3c] mb-2 text-lg">
		{{data.volumeDiscountProfile.profileName}}
	</h2>
	<div *ngFor="let vd of data.volumeDiscountProfile.volumeDiscountProfileItemList"
		 class="w-full flex justify-between items-center gap-3 capitalize">
		<div>For {{vd.minimumOrderQuantity}} / {{data.unit.toLowerCase()}}</div>
		<div>{{selectedCurrency | uppercase}} {{calculateDiscountPrice(vd) |  currencyConverter | number: '1.0-2'}} / {{data.unit.toLowerCase()}}</div>
	</div>
	<div class="fb-disclaimer-box flex items-center gap-2 mt-6">
		<span class="material-symbols-outlined">error</span>
		<p>{{data.volumeDiscountProfile.disclaimer}}</p>
	</div>
</div>
